import { buildSpreaderTable, buildSpreaderCards } from './dependencies/functions-admin.js'


export function initAdmin() {

  var doc = $( document );
  var spreaderData = [];

  var data = { };

  // include csrf token
  var tokenName = window.csrfTokenName;
  data[ tokenName ] = window.csrfTokenValue;

  $.ajax({
    type: "post",
    data: data,
    url: '/actions/tnt/scenarios/get-spreader-settings',
      success: function(response) {

        // make the response JSON parseable
        response = JSON.parse(response);

        spreaderData = response.Spreaders;
        console.log("SPREADER DATA FROM AJAX:", spreaderData)

        $('.spreader-select').removeClass('hidden');
        $('.spreader-loading').addClass('hidden');

        $('.spreader-product-select').select2({
          width: '100%',
          templateSelection: function (data) {
            return data.text;
          },
          "language": {
            "noResults": function () {
              return "Select Country First";
            }
          }
        });

        $('.spreader-country-select').select2({
          width: '100%',
          minimumResultsForSearch: 99999,
          templateSelection: function (data) {
            return data.text;
          }
        });

        // console.log("SPREADER DATA FETCHED AND SAVED");
        // console.log("SPREADER DATA:", response);
      },
    error: function (XMLHttpRequest, textStatus) {
      console.log("Status: " + textStatus);
    }
  }); 

  doc.on( 'change', '.spreader-product-select', function () {

    console.log("CHANGE SPREADER PRODUCT")

    var productCode = $(this).val()
    var productTitle = $(".spreader-product-select option:selected").text();

    console.log(productCode)

    var spreaders = spreaderData.filter(function( obj ) {
        return obj["Part Code"] == productCode;
    });

    console.log(spreaders)

    if (spreaders.length > 0) {

      var spreadertable = buildSpreaderTable(spreaders);
      $("#spreader-table").html(spreadertable)

      var spreaderCards = buildSpreaderCards(spreaders);
      $("#spreader-cards").html(spreaderCards)

    } else {

      $("#spreader-table").html("<p><br/>Spreader settings coming soon for <strong>" + productTitle + "</strong>.</p>")
      $("#spreader-cards").html("<p>Spreader settings coming soon for <strong>" + productTitle + "</strong>.</p>")

    }

  })


}
